import dayjs from 'dayjs';
import type { OrderView } from './order.types';

/**
 * 주문 상태에서 방문 상담 ID 추출
 * @param order 주문 (null이면 null 반환)
 * @returns VisitCounselId 또는 null
 */
export function parseVisitCounselId(order: OrderView | null): string | null {
  if (!order?.status) return null;
  const { type } = order.status;
  if (type === 'VisitAppointed' || type === 'VisitCompleted') return order.status.counsel;
  if (
    type === 'Scheduling' ||
    type === 'ClosedLost' ||
    type === 'Unqualified' ||
    type === 'Requote'
  ) {
    return order.status.counsel ?? null;
  }
  return null;
}

/**
 * 이사일이 임박했는지 확인하는 도메인 로직
 * 이사일이 오늘부터 7일 이내 (0일 이상 7일 이하)인 경우 true를 반환
 *
 * @param moveDate 이사일 (Date 또는 string)
 * @returns 이사일이 임박한 경우 true
 */
export function isMoveDateImminent(moveDate: Date | string | null | undefined): boolean {
  if (!moveDate) return false;

  const moveDateDayjs = dayjs(moveDate);
  if (!moveDateDayjs.isValid()) return false;

  const today = dayjs();
  const daysUntilMove = moveDateDayjs.diff(today, 'day');

  // 1주일 이내 (0일 이상 7일 이하)
  return daysUntilMove >= 0 && daysUntilMove <= 7;
}

/**
 * 평수가 큰지 확인하는 도메인 로직
 * 평수가 45평 이상인 경우 true를 반환
 *
 * @param supplyArea 평수 (number)
 * @returns 평수가 45평 이상인 경우 true
 */
export function isSupplyAreaLarge(supplyArea: number | null | undefined): boolean {
  if (supplyArea === null || supplyArea === undefined) return false;
  return supplyArea >= 45;
}
